import { exportsModule } from '@cian/mf-registry/browser';

import { createHeaderConstructor } from '../services/WebComponentV2/createHeaderConstructor';
import { createApplicationContext } from '../services/applicationContext/createApplicationContext';
import { createApplicationState } from '../services/applicationState';
import { init as initAuthContext } from '../services/authContext';
import { buildAPIRuntime } from '../services/buildAPIRuntime';
import { init as initEvents } from '../services/events';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  initAuthContext(context, store);
  initEvents(context, store, false);

  exportsModule({
    ui: {
      '/v2/get-header-microfrontend/': () => ({
        customElementConstructor: createHeaderConstructor(context, store),
      }),
    },
    // TODO: Разделить API Runtime от UI Runtime в CD-286606.
    api: () => buildAPIRuntime(store),
  });
}
